import React from "react";
import cross_icon from "../../assets/icons/cross_icon.png";
import notify_tasks_icon from "../../assets/icons/notify_tasks_icon.png";
import notify_explore_icon from "../../assets/icons/notify_explore_icon.png";
import notify_bell_icon from "../../assets/icons/notify_bell_icon.png";

const NotificationModal = ({ setNotification }) => {
  return (
    <>
      <div className={`modal-wrapper overflow-y-auto h-full}`}>
        <div className={`side-modal w-[50%] h-screen}`}>
          <div className="flex mt-10 mb-8 justify-center">
            <div className="flex w-[80%] justify-between">
              <p className="text-[#2F80ED]">Notifications</p>
              <div
                onClick={() => setNotification(false)}
                className="cursor-pointer"
              >
                <img src={cross_icon} alt="cross icon" />
              </div>
            </div>
          </div>

          <div className="flex justify-center h-screen">
            <div className="w-[90%] flex flex-col">
              <div className="flex items-center justify-between my-4">
                <div className="flex items-center">
                  <img
                    src={notify_tasks_icon}
                    alt="notification"
                    className="w-6"
                  />
                  <div className="ml-4 text-[14px]">
                    <p className=" font-bold">New task added!</p>
                    <p className="text-[#7C7C7C]">
                      A follow up task for Praveen Sharma has been added!
                    </p>
                  </div>
                </div>
                <p className="text-[12px] text-[#A0A0A0]">2 days ago</p>
              </div>
              <div className="flex items-center justify-between my-4">
                <div className="flex items-center">
                  <img
                    src={notify_explore_icon}
                    alt="notification"
                    className="w-5"
                  />
                  <div className="ml-4 text-[14px]">
                    <p className=" font-bold">Explore the new Exhibition!</p>
                    <p className="text-[#7C7C7C]">
                      There is a new exhibition happening in your city.
                    </p>
                  </div>
                </div>
                <p className="text-[12px] text-[#A0A0A0]">6 days ago</p>
              </div>
              <div className="flex items-center justify-between my-4">
                <div className="flex items-center">
                  <img
                    src={notify_bell_icon}
                    alt="notification"
                    className="w-6 object-contain"
                  />
                  <div className="ml-4 text-[14px]">
                    <p className=" font-bold">Task Reminder!</p>
                    <p className="text-[#7C7C7C]">
                      Follow up email to Rahul Shah by tomorrow
                    </p>
                  </div>
                </div>
                <p className="text-[12px] text-[#A0A0A0]">9 days ago</p>
              </div>
              <div className="flex items-center justify-between my-4">
                <div className="flex items-center">
                  <img
                    src={notify_bell_icon}
                    alt="notification"
                    className="w-6 object-contain"
                  />
                  <div className="ml-4 text-[14px]">
                    <p className=" font-bold">Its Rahul Shah's Birthday!</p>
                    <p className="text-[#7C7C7C]">
                      Wish Rahul Shah, today it's his Birthday.
                    </p>
                  </div>
                </div>
                <p className="text-[12px] text-[#A0A0A0]">9 days ago</p>
              </div>
              <div className="flex items-center justify-between my-4">
                <div className="flex items-center">
                  <img
                    src={notify_bell_icon}
                    alt="notification"
                    className="w-6 object-contain"
                  />
                  <div className="ml-4 text-[14px]">
                    <p className=" font-bold">Rahul Shah's Anniversary</p>
                    <p className="text-[#7C7C7C]">
                      Wish Rahul Shah, it's his Anniversary today.
                    </p>
                  </div>
                </div>
                <p className="text-[12px] text-[#A0A0A0]">9 days ago</p>
              </div>
              <div className="flex items-center justify-between my-4">
                <div className="flex items-center">
                  <img
                    src={notify_bell_icon}
                    alt="notification"
                    className="w-6 object-contain"
                  />
                  <div className="ml-4 text-[14px]">
                    <p className=" font-bold">Subscription Renewal</p>
                    <p className="text-[#7C7C7C]">
                      Its time to Renew your Subscription plan.
                    </p>
                  </div>
                </div>
                <p className="text-[12px] text-[#A0A0A0]">9 days ago</p>
              </div>
              <div className="flex items-center justify-between my-4">
                <div className="flex items-center">
                  <img
                    src={notify_bell_icon}
                    alt="notification"
                    className="w-6 object-contain"
                  />
                  <div className="ml-4 text-[14px]">
                    <p className=" font-bold">Lead attended Exhibition</p>
                    <p className="text-[#7C7C7C]">
                      Rahul Shah, your lead has attended the exhibition.
                    </p>
                  </div>
                </div>
                <p className="text-[12px] text-[#A0A0A0]">9 days ago</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationModal;
